import Registry from '../Registry';
import Popup from './Popup';
import $ from "jquery";

export default class SessionPopup extends Popup {

    constructor(opts = {}){
        Registry.d("SessionPopup.constructor");
        super(opts, "agenda", 'Agenda Details Popup');
        this.language = opts.language ? opts.language : "eng";
        this.widget_id = opts.widget_id ? opts.widget_id : 0;
        this.session_id = opts.session_id ? opts.session_id : 0;
        this.mode = opts.mode ? opts.mode : "large";
        this.index = 0;
        this.checkbox_disabled = false;
        this.link = this.getLink();
        this.website_id = opts.website_id ? opts.website_id : 0;
        this.account_id = opts.account_id;
    }

    setSessionId(id){
        return this.session_id = id;
    }

    setWidgetId(id){
        return this.widget_id = id;
    }

    setIndex(index){
        return this.index = index;
    }

    setCheckboxDisabled(checkbox_disabled){
        return this.checkbox_disabled = checkbox_disabled;
    }

    setWebsiteId(id){
        return this.website_id = id;
    }

    getLink() {
        return `${Registry.baseURL}/${Registry.widget_link}/${this.account_id}/agenda/${this.widget_id}/${this.mode}/session_popup/${this.session_id}/${this.index}/${this.language}/${this.checkbox_disabled}/${this.website_id}`;
    }

    show() {
        this.body.css('overflow', 'hidden');
        let ret = this.iframe.show().css(this.options.css);

        let $iframe = this.iframe[0];
        $iframe.focus();

        var focusableElString = 'a[href],input:not([disabled]),[tabindex="0"]';
        var modal = $($iframe).contents();
        var focusableElements = modal.find(focusableElString);
        var firstTabStop = focusableElements[0];
        var lastTabStop = focusableElements[focusableElements.length - 1];
        firstTabStop.focus();
        modal.find('body').off().on('keydown',function(e){
            if(e.shiftKey && e.keyCode == 9){
                if(e.target === firstTabStop){
                    e.preventDefault();
                    lastTabStop.focus();
                }
            } else if(e.keyCode == 9){
                if(e.target === lastTabStop){
                    e.preventDefault();
                    firstTabStop.focus();
                }
            }
        });

        return ret;
    }

    hide() {
        this.body.css('overflow', '');
        return this.iframe.hide();
    }
}



// WEBPACK FOOTER //
// ./src/embed/popups/SessionPopup.es6